import { dmApi } from "../../../app/dmApi";
import { getAuthorizationHeader, handleQueryError, handleQueryErrorAndSuccess } from "../../../helpers/RtkQueryUtils";
import { serialize } from "../../../helpers/Utils";
export const packingWashingApi = dmApi.injectEndpoints({
    endpoints: (build) => ({
        addPackingMorningEmployee: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/packing-data/washing/add-ms-emp-data`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['morningEmployee', 'employee', 'packingSummary'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Added", "Employee")

            },

        }),
        addPackingEveningEmployee: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/packing-data/washing/add-es-emp-data`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['eveningEmployee', 'employee', 'packingSummary'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Added", "Employee")

            },

        }),
        updatePackingMorningEmployee: build.mutation({
            query: ({ id, requestBody }) => {
                return {
                    url: `/packing-data/washing/update-ms-emp-data/${id}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['morningEmployee', 'employee', 'packingSummary'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Data")
            },
        }),
        updatePackingEveningEmployee: build.mutation({
            query: ({ id, requestBody }) => {
                return {
                    url: `/packing-data/washing/update-es-emp-data/${id}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['eveningEmployee', 'employee', 'packingSummary'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Data")
            },
        }),
        getPackingMorningEmployee: build.query({
            query: (data) => {

                let paramData = serialize(data);

                return {
                    url: `/packing-data/washing/ms-emp-logs?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['morningEmployee'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getPackingEveningEmployee: build.query({
            query: (data) => {

                let paramData = serialize(data);

                return {
                    url: `/packing-data/washing/es-emp-logs?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['eveningEmployee'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),


    }),
});

export const {
    useAddPackingMorningEmployeeMutation,
    useAddPackingEveningEmployeeMutation,
    useGetPackingEveningEmployeeQuery,
    useGetPackingMorningEmployeeQuery,
    useUpdatePackingEveningEmployeeMutation,
    useUpdatePackingMorningEmployeeMutation

} = packingWashingApi;